import React from 'react';
import { useSelector } from 'react-redux';

const Diagram = () => {
    const drawing = useSelector(state => state.drawing);

    return <div
        id="outputArea"
        className="mt-4 p-2 rounded-md"
        dangerouslySetInnerHTML={{ __html: drawing.svg }}
    />
}

export default Diagram;
